import React from '../helpers/react';
import {postReview, toggleThumbdown, toggleThumbup, thumbdownDone, selectReason} from '../actions/review.action.js';
import {connect} from '../helpers/composeReducer.js';
import ReviewOption from '../components/ReviewOption.js';
import Tooltip from '../components/Tooltip.js';
import classList from 'ereader-core/dist/classList';
import {getHookClass} from '../helpers/cssHooks.js';
import {REVIEW_OTHER_ID} from '../modules/apiWrapper.js';

import {trigger} from '../helpers/events.js';

export const ReviewBox =  React.createClass({
    getInitialState: function(){
        return {};
    },
    componentDidMount: function() {
        if (this.props.show_reviews) {
            document.body.addEventListener('click', this.closeTooltips);
        }
        this.componentDidUpdate();
    },

    componentDidUpdate : function(){
        trigger('contentUpdate');
    },
    componentWillUnmount: function() {
        if (this.props.show_reviews) {
            document.body.removeEventListener('click', this.closeTooltips);
        }
    },
	postReview : function(review) {
		review.id = this.my_review.id;
        review.chapterId = this.props.problem.chapter.chapterId;
        review.isbn13 = this.props.isbn13;
		this.props.postReview(review);
	},
	thumbUp : function(){
        this.props.toggleThumbup(this.props.review_box.thumbup);
		this.postReview({
			solutionId: this.props.problem.solution_id,
			reviewValue: "0"
		});
        trigger('reviewClicked', {
          isbn13: this.props.isbn13,
          chapterId: this.props.problem.chapter.chapterId,
          problemId: this.props.problem.problemId,
          reviewValue: "0"
        });
        document.getElementById('notification').setAttribute('aria-hidden' , 'false');
        document.getElementById('notification').innerHTML = this.props.getDef('review-box.thumbs-up-after');
	},
	thumbDown: function(){
		this.props.toggleThumbdown(this.props.review_box.thumbdown);
        document.getElementById('notification').setAttribute('aria-hidden' , 'false');
        document.getElementById('notification').innerHTML = this.props.getDef('review-box.thumbs-down-thanks');
        document.getElementById('notification').innerHTML += this.props.getDef('review-box.thumbs-down-after') + this.props.getDef('review-box.thumbs-down-after-drop-down-aria-description');
	},
    commentChange: function(e){
        this.setState({
            comment: e.target.value
        })
    },
    selectReason: function(reasonId) {
        this.props.selectReason(reasonId);
    },
	sendReason: function(){
		this.postReview({
            solutionId: this.props.problem.solution_id,
			reviewValue: "1",
			reason: this.props.review_box.reason_id,
			comment: this.state.comment
		});
        this.props.thumbdownDone(false);
        trigger('reviewClicked', {
          isbn13: this.props.isbn13,
          chapterId: this.props.problem.chapter.id,
          problemId: this.props.problem.id,
          reasonId: this.props.review_box.reason_id,
          ratingComment: this.state.comment,
          reviewValue: "1"
       });
	},
    cancelClicked: function(){
        this.props.toggleThumbdown(true);
        this.props.thumbdownDone(true);
    },
    closeTooltips: function(e){
        let reviewData = this.props.review_box;

        if (reviewData.thumbup && !this.refs.thumbsup.contains(e.target)) {
            this.props.toggleThumbup(true);
        }
        if ((reviewData.thumbdown || reviewData.thumbdown_done)
            && !this.refs.thumbsdown.contains(e.target)) {
            this.props.toggleThumbdown(true);
            this.props.thumbdownDone(true);
        }
        var toRemoveClickToolTipOnHover = document.getElementsByClassName("button-wrapper-up clicked");
        if(toRemoveClickToolTipOnHover.length > 0) {
            toRemoveClickToolTipOnHover[0].classList.remove("clicked");
        }
    },
    onOverThumb: function(e) {
        this.closeTooltips(e);
    },

	render : function(){
        if (!this.props.show_reviews) {
            return <div></div>;
        }

        let reviewData = this.props.review_box;
		this.my_review = reviewData.user_reviews[0] || {};

		let reviewOptions = [];
        let comment_required = (reviewData.reason_id == REVIEW_OTHER_ID);
        let commentPlaceholder = comment_required ? this.props.getDef('review-box.additional-details-required') : this.props.getDef('review-box.additional-details-optional');
        let commentClass = classList('review-comment-box');
        if (typeof reviewData.reason_id === 'undefined') {
            commentClass.push('disabled');
        }
        let submit_disabled = false;
        if (comment_required && !this.state.comment) {
            commentClass.push('required');
            submit_disabled = 'disabled';
        }
        for (let reviewOptionId in this.props.review_options) {
			let reviewOption = this.props.review_options[reviewOptionId];
			let reviewOptionChild = null;
            if(reviewOption.reason.toString().toLowerCase() === "other") {
                reviewOptionChild = <div className={commentClass}><textarea id={`review-id-${reviewOption.id}`} placeholder={commentPlaceholder} onChange={this.commentChange}></textarea></div>;
            }
			reviewOptions.push(
                <ReviewOption
                    key={reviewOptionId}
                    review={reviewOption}
                    selected_reason={reviewData.reason_id}
                    selectReason={this.selectReason}
                    getDef={this.props.getDef}
            >{reviewOptionChild}</ReviewOption>
            );
        }
		reviewOptions.push(
                <div className="review-buttons">
                    <button className="cancel-button link-button" onClick={this.cancelClicked} aria-label="Cancel feedback">{this.props.getDef('review-box.cancel')}</button>
                    <button className="submit-button" disabled={submit_disabled} onClick={this.sendReason} aria-label="Submit feedback">{this.props.getDef('review-box.submit')}</button>
                </div>
        );

		let upWrapperClass = classList('button-wrapper', 'button-wrapper-up');
		if (reviewData.thumbup) {
			upWrapperClass.push('clicked');
		}
		if (this.my_review.reviewValue == '0') {
			upWrapperClass.push('on');
		}

		let downWrapperClass = classList('button-wrapper', 'button-wrapper-down');
        if (reviewData.thumbdown_done) {
            downWrapperClass.push('after-clicked');
        }
		else if (reviewData.thumbdown) {
			downWrapperClass.push('clicked');
        }
		if (this.my_review.reviewValue == '1') {
			downWrapperClass.push('on');
		}

        let is_problem_loaded = this.props.problem.hasSolution && this.props.problem.steps.length;
        let body = '';
        if (is_problem_loaded) {
            body = [
                <h3 key="h3" className="review-header">{this.props.getDef('review-box.solution-clear-enough')}</h3>,
                <div ref="thumbsup" key="thumbsup" className={upWrapperClass}>
                    <div hidden={true} id="thumbup-description">{ this.props.getDef('review-box.thumbs-up-description', {thumbup : reviewData.counts.like}) }</div>
                    <button className="thumb thumb-up" onClick={this.thumbUp} onMouseOver={this.onOverThumb} aria-describedby="thumbup-description" aria-label={this.props.getDef('review-box.solution-clear-enough')}>{reviewData.counts.like}</button>
                    <Tooltip showOn="hover" ref="up-hover" role={"dialog"} ariaText="thumbs up thanks">
                        {this.props.getDef('review-box.thumbs-up-thanks')}
                    </Tooltip>
                    <Tooltip showOn="clicked" role={"dialog"} ref="up-clicked" ariaText="thumbs up clicked">
                        {this.props.getDef('review-box.thumbs-up-after')}
                    </Tooltip>
                </div>,
                <div ref="thumbsdown" key="thumbsdown" className={downWrapperClass}>
                    <div hidden={true} id="thumbdown-description">{ this.props.getDef('review-box.thumbs-down-description', {thumbdown : reviewData.counts.dislike}) }</div>
                    <button className="thumb thumb-down" onClick={this.thumbDown} onMouseOver={this.onOverThumb} aria-describedby="thumbdown-description" aria-label={this.props.getDef('review-box.solution-clear-enough')}>{reviewData.counts.dislike}</button>
                    <Tooltip showOn="hover" role={"dialog"} ref="down-hover" ariaText="thumbs down hover">
                        {this.props.getDef('review-box.thumbs-down-thanks')}
                    </Tooltip>
                    <Tooltip showOn="clicked" role={"dialog"} ref="down-clicked" ariaText="thumbs down on clicked suggestion">
                        <h4>{this.props.getDef('review-box.thumbs-down-after')}</h4>
                        <ul>
                            {reviewOptions}
                        </ul>
                    </Tooltip>
                    <Tooltip showOn="after-clicked" ref="down-after-clicked" ariaText="thumbs down after clicked suggestion" role={"dialog"}>
                        {this.props.getDef('review-box.thumbs-down-after-clicked')}
                    </Tooltip>
                </div>
            ];
        }

        let mainClass = classList('review-box', getHookClass('ReviewBox'));

        return (
            <section className={mainClass}>
                {body}
            </section>
        );
	}
});

export function mapStateToProps(state){

	return {
		problem : state.problem,
        review_box : state.review_box,
		review_options : state.model.review_data,
        show_reviews: state.options.show_reviews,
        getDef : state.helpers.getDef,
        isbn13 : state.model.isbn13
	};
}

export default connect(mapStateToProps,{
    postReview,
    toggleThumbdown,
    toggleThumbup,
    thumbdownDone,
    selectReason
})(ReviewBox);



// WEBPACK FOOTER //
// ./src/components/ReviewBox.js